import { FUNDAMENT_PREFIX } from '@app/fundament/fundament-prefix';
import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  prefix = FUNDAMENT_PREFIX;

  active = true;

  @Input() isDismissable = true;

  @Output() close: EventEmitter<MouseEvent> = new EventEmitter();

  dismiss(event: MouseEvent): void {
    this.hide();
    this.close.emit(event);
  }

  private hide() {
    this.active = false;
  }
}
